






























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapActions } from 'vuex';
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import TextField from "@/components/inputs/TextField.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import Select35 from "@/components/inputs/Select35.vue";
import Decimal from "@/components/inputs/Decimal.vue";
import Email from "@/components/inputs/Email.vue";
import Dates from "@/components/inputs/dates.vue";
import SsoUserPicker from "@/components/inputs/SsoUserPicker.vue";
import ProductPicker from "@/components/inputs/ProductPicker.vue";
import ProductStockPicker from "@/components/inputs/ProductStockPicker.vue";
import { JobType } from "@/enum/JobType";
import LicenseInfo from "@/components/LicenseInfo.vue";
import { Products } from "@/enum/Products";

class Job {
  type_id: JobType = JobType.CreateTenant;
  status: string = "WAITING";
  args: Hesap = new Hesap();
}

class Hesap {
  id: number = 0;
  first_name: string = "";
  last_name: string = "";
  email: string = "";
  kimlik_no: string = "";
  old_email: string = "";
  new_email: string = "";
  old_tckn: string = "";
  new_tckn: string = "";
  office_name: string = "";
  sso_user_id: number = 0;
  lisans_suresi: number = 0;
  product: any = null;
  product_id: number = 0;
  package: any = null;
  package_id: number = 0;
  aktar_mi: boolean = false;
  isEditing: boolean = false;
}

class SsoHesap {
  id: number = 0;
  first_name: string = "";
  last_name: string = "";
  email: string = "";
  kimlik_no: string = "";
  sso_user_id: number = 0;
  office_name: string = "";
}

interface License {
  user_id: number;
  tenant_id: string;
  product_id: number;
  start_date: string;
  old_licenses_date: string;
  new_licenses_date: string;
}

@Component({
  components: {
    ProductStockPicker,
    ProductPicker,
    SsoUserPicker,
    Dates,
    Email,
    Decimal,
    Select35,
    Id,
    EForm,
    TextField,
    DeleteButton,
    LicenseInfo
  },
  methods: {
    ...mapActions(['updateTransfer']),
  },
})
export default class Hesaplar extends Vue {
  dialog: boolean = false;
  editDialog: boolean = false;
  formValid: boolean = false;
  confirmDialog: boolean = false;
  emailCollisionDialog: boolean = false;

  emailExists: boolean = false;
  isUserChange: boolean = false;
  emailCheckSsoId: number = 0;

  editedItem: Hesap = new Hesap();
  editedSsoItem: SsoHesap = new SsoHesap();
  snackbar: boolean = false;
  snackbarText: string = '';
  snackbarTimeout: number = 3000;
  action: string = this.$store.state.icwApiUrl + 'admin/job';
  data = new Job();
  title: string = "";
  loading: boolean = true;
  editingField: string = '';
  licensesDialog: boolean = false;
  currentLicenses: any[] = [];

  // Pagination and search states
  search: string = "";
  hesaplar: Hesap[] = [];
  options: any = {};
  totalHesaplar: number = 0;
  searchDebounce: any = null;

  headers = [
    { text: "Id", value: "id" },
    { text: "TCKN", value: "kimlik_no" },
    { text: "Ad", value: "first_name" },
    { text: "Soyad", value: "last_name" },
    { text: "Kurum Adı", value: "office_name" },
    { text: "e-posta", value: "email" },
    { text: "Oluşturulma Tarihi", value: "created_at" },
    { text: "Güncellenme Tarihi", value: "updated_at" },
    { text: "Hesap Türü", value: "type_id" },
    { text: "Lisanslar", value: "licenses" },
    { text: "Aktar", value: "aktar_mi" },
  ];
  noSpacesRule = (v: string) => !/\s/.test(v) || 'Boşluk eklenemez';
  tcknValidationRule = (v: string) => this.isValidTCKN(v) || 'Geçerli bir TCKN giriniz';
  emailValidationRule = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta giriniz';

  @Watch('options', { deep: true })
  onOptionsChange() {
    this.loadHesaplar();
  }

  @Watch('search')
  onSearchChange() {
    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(() => {
      this.options.page = 1;
      this.loadHesaplar();
    }, 500);
  }

  async loadHesaplar() {
    try {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      const params: any = {
        page,
        per_page: itemsPerPage,
        search: this.search,
      };

      if (sortBy && sortBy.length > 0 && sortDesc && sortDesc.length > 0) {
        params.sort_by = sortBy[0];
        params.sort_dir = sortDesc[0] ? 'desc' : 'asc';
      }

      const response = await this.$http.get(`${this.$store.state.icwApiUrl}admin/users`, { params });

      if (response.data && Array.isArray(response.data.data)) {
        this.hesaplar = response.data.data;
        this.totalHesaplar = response.data.total;
      }
    } catch (e) {
      console.error("Veri yükleme hatası:", e);
      this.$toast.error("Kullanıcılar yüklenirken bir hata oluştu.");
    } finally {
      this.loading = false;
    }
  }

  formatDate(date: string) {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(date).toLocaleDateString('tr-TR', options);
  }

  changeEmail(item: Hesap) {
    // SsoHesap nesnesi oluşturup değerleri aktaralım
    this.editedSsoItem = new SsoHesap();
    this.editedSsoItem.id = item.id;
    this.editedSsoItem.first_name = item.first_name;
    this.editedSsoItem.last_name = item.last_name;
    this.editedSsoItem.email = item.email;
    this.editedSsoItem.kimlik_no = item.kimlik_no;
    this.editedSsoItem.sso_user_id = item.sso_user_id;
    this.editedSsoItem.office_name = item.office_name;
    
    // Geriye dönük uyumluluk için Hesap nesnesini de güncelleyelim
    this.editedItem = {
      ...item,
      old_email: item.email,
      new_email: item.email
    };
    this.editingField = 'email';
    this.editDialog = true;
  }

  changeTCKN(item: Hesap) {
    this.editedItem = {
      ...item,
      old_tckn: item.kimlik_no,
      new_tckn: item.kimlik_no
    };
    this.editingField = 'tckn';
    this.editDialog = true;
  }

  closeEditDialog() {
    this.editDialog = false;
  }

  async confirmSave() {
    const form = this.$refs.editForm as Vue & { validate: () => boolean };
    if (form.validate()) {
      if (this.editingField === 'email') {
        try {
          const checkResponse = await this.$http.post(
              this.$store.state.icwApiUrl + 'admin/user-email-check',
              { email: this.editedItem.new_email }
          );
          const exists = checkResponse.data.data?.exists === true;
          this.emailExists = exists;

          console.log("API tam yanıt:", checkResponse);
          console.log("API yanıt iç yapısı:", checkResponse.data);
          console.log("E-posta kontrolü sonucu (exists):", checkResponse.data.data?.exists);
          console.log("Dönüştürülmüş exists değeri:", exists);

          // API yanıtını ve yapısını detaylı olarak inceleyelim
          console.log("API yanıtının doğrudan içeriği !!!!!:", checkResponse);
          console.log("data özelliği:", checkResponse.data);
          console.log("data.data özelliği:", checkResponse.data.data);
          console.log("data.user özelliği:", checkResponse.data.user);
          
          // Ekran görüntüsünde görülen yapıya göre, doğru yol:
          if (checkResponse.data && checkResponse.data.user && checkResponse.data.user.id) {
            this.emailCheckSsoId = checkResponse.data.user.id;
          } else if (checkResponse.data && checkResponse.data.data && checkResponse.data.data.user && checkResponse.data.data.user.id) {
            this.emailCheckSsoId = checkResponse.data.data.user.id;
          } else {
            // Objeyi derinlemesine arayarak ID'yi bulmaya çalış
            const findId = (obj) => {
              if (!obj || typeof obj !== 'object') return null;
              if (obj.id && typeof obj.id === 'number') return obj.id;
              
              for (const key in obj) {
                if (key === 'user' && obj[key] && obj[key].id) {
                  return obj[key].id;
                }
                const found = findId(obj[key]);
                if (found) return found;
              }
              return null;
            };
            
            this.emailCheckSsoId = findId(checkResponse.data) || 0;
          }
          
          console.log("Bulunan ID değeri:", this.emailCheckSsoId);
          
          // SsoHesap nesnesini de güncelleyelim
          if (this.emailExists) {
            console.log("Bulunan SSO kullanıcı ID'si:", this.emailCheckSsoId);
          }
          if (this.emailExists) {
            this.emailCollisionDialog = true;
          } else {
            this.isUserChange = false;
            this.confirmDialog = true;
            this.editDialog = false;
          }
        } catch (error) {
          console.error("E-posta kontrolü hatası:", error);
          this.$toast.error("E-posta kontrolü yapılırken hata oluştu.");
        }
      } else {
        this.confirmDialog = true;
        this.editDialog = false;
      }
    } else {
      this.$toast.error('Lütfen geçerli bilgiler giriniz.');
    }
  }

  closeConfirmDialog() {
    this.confirmDialog = false;
  }

  selectExistingAccount() {
    this.isUserChange = true;
    this.emailCollisionDialog = false;
    this.confirmDialog = true;
  }

  selectNewEmail() {
    this.isUserChange = false;
    this.emailCollisionDialog = false;
    this.confirmDialog = true;
  }

  async onTransferChange(item) {
    const newStatus = item.aktar_mi;
    const statusText = newStatus ? 'aktif' : 'pasif';
    const previousStatus = !newStatus;

    try {
      const apiUrl = `${this.$store.state.icwApiUrl}admin/user/${item.id}`;
      const payload = {
        aktar_mi: newStatus
      };
      const response = await this.$http.post(apiUrl, payload);

      if (response.data.success) {
        this.$toast.success(`Kullanıcı aktarım durumu ${statusText} olarak güncellendi.`);
      } else {
        const errorDetail = response.data.message || response.data.error || 'Bilinmeyen bir hata oluştu';
        this.$toast.error(`Aktarım durumu ${statusText} olarak güncellenemedi.`, {
          timeout: 3000,
        });
        setTimeout(() => {
          this.$toast.error(`Hata nedeni: ${errorDetail}`, {
            timeout: 4000
          });
        }, 3000);
        item.aktar_mi = previousStatus;
        setTimeout(() => {
          this.$toast.info(`Aktarım durumu ${previousStatus ? 'aktif' : 'pasif'} olarak kaldı.`);
        }, 7000);
      }
    } catch (e) {
      console.error("API Hatası:", e);

      let errorMessage = "Bir hata oluştu. ";
      let errorDetail = "";

      if (e.response) {
        switch (e.response.status) {
          case 400:
            errorMessage += "Geçersiz istek yapıldı. Lütfen sayfayı yenileyip tekrar deneyin.";
            errorDetail = e.response.data?.message || "İstek parametreleri geçersiz formatta.";
            break;
          case 401:
            errorMessage += "Oturum süreniz dolmuş olabilir. Lütfen yeniden giriş yapın.";
            errorDetail = "Oturum doğrulaması başarısız.";
            break;
          case 403:
            errorMessage += "Bu işlem için yetkiniz bulunmuyor. Yöneticinizle iletişime geçin.";
            errorDetail = "Yetkilendirme hatası: Erişim engellendi.";
            break;
          case 404:
            errorMessage += "Kullanıcı sistemde bulunamadı. Sayfa yenilendikten sonra tekrar deneyin.";
            errorDetail = "Kullanıcı kaydı veritabanında bulunamadı.";
            break;
          case 422:
            errorMessage += "Gönderilen veriler geçersiz. Lütfen tekrar deneyin.";
            errorDetail = e.response.data?.errors?.join(', ') || "Veri doğrulama hatası.";
            break;
          case 500:
            errorMessage += "Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.";
            errorDetail = "Sunucu işlem hatası: " + (e.response.data?.message || "İç sunucu hatası");
            break;
          default:
            errorMessage += "Beklenmeyen bir hata oluştu. Sistem yöneticinizle iletişime geçin.";
            errorDetail = `Hata kodu: ${e.response.status}, Detay: ${e.response.data?.message || 'Bilinmeyen hata'}`;
        }
      } else if (e.request) {
        errorMessage += "Sunucuya ulaşılamıyor. İnternet bağlantınızı kontrol edip tekrar deneyin.";
        errorDetail = "Ağ bağlantısı hatası: Sunucudan yanıt alınamadı.";
      } else {
        errorMessage += e.message || "Bilinmeyen bir hata oluştu. Lütfen daha sonra tekrar deneyin.";
        errorDetail = "Sistem hatası: " + (e.message || "Tanımlanamayan hata");
      }

      this.$toast.error(errorMessage, {
        timeout: 3000,
      });
      setTimeout(() => {
        this.$toast.error(`Teknik detay: ${errorDetail}`, {
          timeout: 4000
        });
      }, 3000);

      item.aktar_mi = previousStatus;
      setTimeout(() => {
        this.$toast.info(
            `Aktarım durumu değişiklikleri iptal edildi. Kullanıcı ${previousStatus ? 'aktif' : 'pasif'} durumda kalmaya devam edecek.`,
            {
              timeout: 5000
            }
        );
      }, 7000);
    }
  }

  async saveField() {
    try {
      const form = this.$refs.editForm as Vue & { validate: () => boolean };
      if (!form.validate()) {
        this.$toast.error('Lütfen geçerli bilgiler giriniz.');
        return;
      }
      if (!this.editedItem.id) {
        console.error("Güncellenmek istenen öğenin ID'si bulunamadı.");
        alert("ID eksik olduğu için güncelleme yapılamıyor.");
        return;
      }

      let apiUrl = '';
      let payload = {};

      if (this.editingField === 'email') {
        apiUrl = `${this.$store.state.icwApiUrl}admin/user-email-change`;

        const emailExistsValue = this.emailExists === true;
        const isUserChangeValue = this.isUserChange === true;
        
        // Ekran görüntüsündeki API yanıtı ve hata mesajına göre payload'u ayarlıyoruz
        payload = {
          is_exists: emailExistsValue,
          is_user_change: isUserChangeValue,
          old_email: String(this.editedItem.old_email || ''),
          new_email: String(this.editedItem.new_email || '')
        };
        
        console.log("Mevcut kullanıcı ID:", this.editedItem.id);
        console.log("E-posta kontrolünden alınan ID:", this.emailCheckSsoId);
        if (emailExistsValue === true) {
          console.log("E-posta var, ek alanlar ekleniyor.");

          if (isUserChangeValue === true) {
            payload = {
              ...payload,
              old_sso_id: this.editedItem.id,
              new_sso_id: this.emailCheckSsoId,
              duplicate_sso_id: this.editedItem.sso_user_id,
              sso_id: this.emailCheckSsoId,
              id: this.editedItem.id
            };
          } else {
            payload = {
              ...payload,
              duplicate_sso_id: this.editedItem.sso_user_id,
              sso_id: this.emailCheckSsoId,
              id: this.editedItem.id,
              email: this.editedItem.new_email
            };
          }
        } else {
          console.log("E-posta mevcut değil, standart payload kullanılıyor:", payload);
        }
        this.snackbarText = 'E-posta adresi başarıyla güncellendi.';
      } else if (this.editingField === 'tckn') {
        apiUrl = `${this.$store.state.icwApiUrl}admin/user-tckn-change`;
        payload = {
          email: this.editedItem.email,
          new_tckn: this.editedItem.new_tckn,
        };
        this.snackbarText = 'TCKN başarıyla güncellendi.';
      }

      console.log("İstek URL'si:", apiUrl);
      console.log("Gönderilen Veriler (API çağrısı öncesi):", JSON.stringify(payload));
      const response = await this.$http.post(apiUrl, payload);

      console.log(`${this.editingField} güncellemesi için API Yanıtı:`, response.data);

      if (response.status === 200) {
        const isSuccess = (
            response.data?.success === true ||
            response.data?.data?.Success === true ||
            response.data?.data?.success === true
        );

        console.log("API yanıt detaylı kontrol:", {
          directSuccess: response.data?.success,
          nestedSuccess: response.data?.data?.Success,
          nestedSuccessLower: response.data?.data?.success,
          finalResult: isSuccess
        });

        if (isSuccess) {
          console.log("Başarılı API yanıtı alındı, yerel veriyi güncelliyorum.");

          const updatedItemIndex = this.hesaplar.findIndex((item: Hesap) => item.id === this.editedItem.id);
          if (updatedItemIndex !== -1) {
            if (this.editingField === 'email') {
              // E-posta güncellemesi başarılı, yerel listeyi güncelle
              this.hesaplar[updatedItemIndex].email = this.editedItem.new_email;
              console.log(`E-posta başarıyla güncellendi: ${this.editedItem.old_email} -> ${this.editedItem.new_email}`);
            } else if (this.editingField === 'tckn') {
              // TCKN güncellemesi başarılı, yerel listeyi güncelle
              this.hesaplar[updatedItemIndex].kimlik_no = this.editedItem.new_tckn;
              console.log(`TCKN başarıyla güncellendi: ${this.editedItem.old_tckn} -> ${this.editedItem.new_tckn}`);
            }
            this.snackbar = true;
          } else {
            console.warn("Güncellenen öğe listede bulunamadı, id:", this.editedItem.id);
          }
        } else {
          console.error("API yanıtı başarısız:", response.data);
          this.$toast.error('Güncelleme işlemi başarısız oldu.');
        }
      } else {
        console.error("API Yanıtında Beklenmeyen Durum:", response.data);
      }

      this.confirmDialog = false;
    } catch (e) {
      console.error("API Hatası:", e);
      if (e.response) {
        console.error("Sunucu Yanıtı Hatası:", e.response.data);
      }
    } finally {
      await this.loadHesaplar();
    }
  }

  parseDate(dateString) {
    if (!dateString) return new Date().toISOString().split('T')[0];
    const parsedDate = new Date(dateString);
    return isNaN(parsedDate.getTime()) ? new Date().toISOString().split('T')[0] : parsedDate.toISOString().split('T')[0];
  }

  async openLicenseDialog(item) {
    try {
      this.loading = true;

      const response = await this.$http.get(`${this.$store.state.icwApiUrl}admin/users/${item.id}`);
      const licensesData = Object.values(response.data.licenses || {});

      this.currentLicenses = licensesData.flatMap((entry: any) => {
        const buroName = entry.buroName || 'Büro Adı Bulunamadı';

        const licenses = [
          entry.ofisLicenses,
          entry.icwLicenses,
          entry.eIcraLicenses,
          entry.arabulucuLicenses,
          entry.davaLicenses,
        ]
            .filter(Boolean)
            .flat()
            .map((license) => ({
              ...license,
              buroName,
              productName: Products[license.product_id] || 'Bilinmiyor',
              startDateMenu: false,
              endDateMenu: false,
              start_date: this.parseDate(license.start_date),
              old_licenses_date: this.parseDate(license.end_date),
              new_licenses_date: this.parseDate(license.end_date),
            }));

        return licenses;
      }).sort((a, b) => a.productName.localeCompare(b.productName));

      this.licensesDialog = true;
    } catch (e) {
      console.error('Error fetching license data:', e);
      alert('Lisans bilgilerini yüklerken bir hata oluştu.');
    } finally {
      this.loading = false;
    }
  }

  async saveLicenseChanges(): Promise<void> {
    try {
      let isAdmin = this.$store.state.user.role === 'admin';
      let grantedUserIds = [1,54,317,382]; //emre-umit-didem-sebo
      let userHavePermission = grantedUserIds.find(x=>x == this.$store.state.user.id);
      if(isAdmin && userHavePermission){
        const newLicenses: { [tenantId: string]: License[] } = {};
        for (const license of this.currentLicenses) {
          const tenantId = license.tenant_id;

          if (!newLicenses[tenantId]) {
            newLicenses[tenantId] = [];
          }

          newLicenses[tenantId].push({
            user_id: license.user_id,
            tenant_id: license.tenant_id,
            product_id: license.product_id,
            start_date: license.start_date,
            old_licenses_date: license.old_licenses_date,
            new_licenses_date: license.new_licenses_date,
          });
        }

        const licenseObj = {
          newLicenses,
        };
        const licenseString = JSON.stringify(licenseObj);
        const apiUrl: string = `${this.$store.state.icwApiUrl}admin/user-licenses-change`;
        const token = localStorage.getItem("token");
        const panelToken = localStorage.getItem("panelToken");

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
            'Panel-Token': `${panelToken}`,
          },
          body: licenseString,
        });

        const data = await response.json();

        if (response.status === 200 && data.success) {
          this.$toast.success("Lisanslar başarıyla güncellendi.");
        } else {
          console.error("Beklenmedik yanıt:", data);
          this.$toast.error("Lisans güncellenemedi. Lütfen tekrar deneyin.");
        }

        this.closeLicenseDialog();

      }else{
        this.$toast.error("Lisans değiştirme yetkiniz bulunamadı !");
      }
    } catch (e) {
      console.error("Lisansları güncellerken hata oluştu:", e);
      this.$toast.error("Lisans bilgilerini güncellerken bir hata oluştu.");
    }

  }

  mounted(){
    console.log("store state user",this.$store.state.user);


  }

  closeLicenseDialog() {
    this.licensesDialog = false;
    this.currentLicenses = [];
  }

  removeSpaces(field: string) {
    if (field === 'email') {
      this.editedItem.new_email = this.editedItem.new_email.replace(/\s+/g, '');
    } else if (field === 'tckn') {
      this.editedItem.new_tckn = this.editedItem.new_tckn.toString().replace(/\s+/g, '');
    }
  }

  isValidTCKN(tckn: string): boolean {
    if (!/^\d{11}$/.test(tckn) || tckn[0] === '0') return false;

    const digits = tckn.split('').map(Number);
    const sumOdd = digits[0] + digits[2] + digits[4] + digits[6] + digits[8];
    const sumEven = digits[1] + digits[3] + digits[5] + digits[7];
    const checkDigit10 = ((7 * sumOdd) - sumEven) % 10;
    const checkDigit11 = (digits.slice(0, 10).reduce((acc, val) => acc + val, 0)) % 10;

    return checkDigit10 === digits[9] && checkDigit11 === digits[10];
  }
}
